
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { getApiHeader, getApiHeaderGuest, setUserSession } from "../../../../utils/CommonFunctions";
import DropIn from "braintree-web-drop-in-react";
import swal from "sweetalert";
import whiteLOgo from "../../../../assets/img/logo-white-small.png"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class Payments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            agreeToTerms: false,
            agreeDirectDebit: false,
            clientToken: "",
            errors: {},
            isSubmitting: false,
            hideButton:false
        };
        this.instanceRef = React.createRef();
    }

    componentDidMount() {
        this.fetchToken();
    }

    fetchToken = async () => {
        try {
            this.props.setLoading(true);
            const headers = await getApiHeader();
            const response = await axios.get(`${SERVER_URL}payments/get-client-token`, { headers });
            this.setState({ clientToken: response.data.data.clientToken });
        } catch (error) {
            this.props.setLoading(false);
        } finally {
            this.props.setLoading(false);
        }
    };

    handlecheckTermAndContition = (e) => {
        const isChecked = e.target.checked;
        this.setState((prevState) => ({
            agreeToTerms: isChecked,
            errors: {
                ...prevState.errors,
                agreeToTerms: isChecked ? "" : "Please agree to the Terms & Conditions."
            }
        }));
    };



    handlecheckDirectDebit = (e) => {
        const isChecked = e.target.checked;
        this.setState((prevState) => ({
            agreeDirectDebit: isChecked,
            errors: {
                ...prevState.errors,
                agreeDirectDebit: isChecked ? "" : "Please agree to the Direct Debit Policy."
            }
        }));
    };




    buy = async (e) => {
        e.preventDefault();

        if (!this.state.agreeToTerms) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    agreeToTerms: "Please agree to the Terms & Conditions."
                }
            });
            return;
        }


        if (!this.state.agreeDirectDebit) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    agreeDirectDebit: "Please agree to the Direct Debit Policy."
                }
            });
            return;
        }


        this.setState({ isSubmitting: true });
        this.props.setLoading(true);

        try {
            const { nonce: generatedNonce } = await this.instanceRef.current.requestPaymentMethod();
            const requestData = {
                nonce: generatedNonce,
                refId: this.props.paramValue,
                refIndex: this.props.paramName,
                termsCheck: this.state.agreeToTerms,
                directDebitCheck: this.state.agreeDirectDebit
            };

            const headers = await getApiHeaderGuest();
            const response = await axios.post(`${SERVER_URL}postpaid/s-p-a`, requestData, { headers });

            if (response.status === 200) {
                if (response.data?.data.token && response.data?.data?.user) {
                    setUserSession(response.data?.data?.token, response.data?.data?.user);
                    this.setState({hideButton:true})
                    this.props.setLoading(false);
                    swal({
                        text: response.data.message,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        icon: "success"
                    }).then(() => {
                        // sessionStorage.setItem("is_postpaid", "1");
                        // this.props.history.push("/account-summary");

                        swal({
                            text: "Thank you for choosing Telsim!",
                            buttons: false,
                            closeOnClickOutside: false,
                            closeOnEsc: false,
                            icon: "success"
                        });

                        setTimeout(() => {
                            window.location.replace("https://telsim.com.au");
                        }, 3000);


                    });
                } else {
                    this.setState({hideButton:true})
                    swal({
                        text: response.data.message,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        icon: "success"
                    }).then(() => {
                        // this.props.history.push("/login");
                         window.location.replace("https://telsim.com.au");
                    });

                }
            }
        } catch (error) {
            this.props.setLoading(false)
            this.setState({ isSubmitting: false });

            {
                error?.response?.data?.message && (
                    swal({
                        text: error?.response?.data?.message,
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        icon: "error"
                    }).then(() => {
                        // this.props.history.push("/login");
                         window.location.replace("https://telsim.com.au");
                    })

                )
            }

        } finally {
            this.setState({ isSubmitting: false });
            this.props.setLoading(false);
        }
    };

    render() {
        const { orderDetails, portinDetails, common_data, planMapping } = this.props;

        return (
            <div className="post-paid-common-container">
                <div className="container" style={{ background: "none" }}>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-12">
                            <div className="card post-paid-common-card">
                                <div className="post-paid-common-header">
                                    <img className="postpaid-logo" src={whiteLOgo} alt="Logo" />
                                    {/* <h1 className="post-paid-common-title">Telsim SIM Only Plan Activation</h1> */}
                                    {/* <p className="post-paid-common-subtitle">Payment</p> */}
                                </div>
                                <div>
                                    <h2 className="post-paid-common-title-second">Telsim Upfront Mobile Plan – Customer Terms & Activation Form</h2>
                                </div>

                                <div className="post-paid-common-form">
                                    <div className="row">

                                        {/* Order Details */}
                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                            <div className="order-details-table">
                                                <h3 className="post-paid-common-section-title">Order Details</h3>
                                                <table className="table table-striped post-paid-table-data">
                                                    <tbody>
                                                        {orderDetails?.sim_type && (
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Sim Type :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {orderDetails?.sim_type}</td>
                                                            </tr>


                                                        )}

                                                        {orderDetails?.sim_number && (
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Sim Number :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {orderDetails?.sim_number}</td>
                                                            </tr>


                                                        )}

                                                        {orderDetails?.activation_type && (
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Activation Type :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {orderDetails?.activation_type}</td>
                                                            </tr>

                                                        )}

                                                        {orderDetails?.display_name && (
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Plan Name :</th>
                                                                <td className="post-paid-common-plan-name" style={{ fontSize: "15px", fontWeight: "500" }}>{planMapping?.length > 0 ? <>{planMapping[0].data} <span style={{ textDecoration: "line-through" }}>${planMapping[0].amount}</span> ${planMapping[0].sell_amount} {planMapping[0].description}</> : orderDetails?.display_name}</td>

                                                            </tr>
                                                        )}
                                                        {portinDetails && Object.keys(portinDetails).length > 0 && (
                                                            <>
                                                                {portinDetails.mobile_number && (
                                                                    <tr>
                                                                        <th style={{ fontSize: '14px', fontWeight: '600' }}>Mobile Number :</th>
                                                                        <td style={{ fontSize: '15px', fontWeight: '500' }}>{portinDetails.mobile_number}</td>
                                                                    </tr>
                                                                )}
                                                                {portinDetails.mobile_provider && (
                                                                    <tr>
                                                                        <th style={{ fontSize: '14px', fontWeight: '600' }}>Mobile Provider :</th>
                                                                        <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.mobile_provider}</td>
                                                                    </tr>
                                                                )}
                                                                {portinDetails.port_service_type && (
                                                                    <tr>
                                                                        <th style={{ fontSize: '14px', fontWeight: '600' }}>Service Type :</th>
                                                                        <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.port_service_type}</td>
                                                                    </tr>
                                                                )}
                                                                {portinDetails.port_dob && (
                                                                    <tr>
                                                                        <th style={{ fontSize: '14px', fontWeight: '600' }}>Date of Birth :</th>
                                                                        <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.port_dob}</td>
                                                                    </tr>
                                                                )}
                                                                {portinDetails.port_account_id && (
                                                                    <tr>
                                                                        <th style={{ fontSize: '14px', fontWeight: '600' }}>Account ID :</th>
                                                                        <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.port_account_id}</td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        )}



                                                        {common_data?.Activation_from === 'TAP' ? (
                                                            <tr>
                                                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Payment Status :</th>
                                                                <td style={{ fontSize: '15px', fontWeight: '500' }}> Paid</td>
                                                            </tr>
                                                        ) : (
                                                            orderDetails?.total_amount && (
                                                                <tr>
                                                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Total Amount :</th>
                                                                    <td style={{ fontSize: '15px', fontWeight: '500' }}> ${orderDetails?.total_amount}</td>
                                                                </tr>
                                                            )
                                                        )}




                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Divider */}
                                        <div className="col-lg-1 d-flex justify-content-center align-items-center">
                                            <div style={{ width: "2px", height: "100%", backgroundColor: "#ccc" }}></div>
                                        </div>

                                        {/* Payment Info */}
                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                            <div className="personal-info-table">
                                                <h3 className="post-paid-common-section-title">{common_data.Payment_section_heading}</h3>
                                                {this.state.clientToken && (
                                                    <DropIn
                                                        options={{ authorization: this.state.clientToken }}
                                                        onInstance={(instance) => (this.instanceRef.current = instance)}
                                                    />
                                                )}

                                                <p style={{ fontWeight: '400', textAlign: 'justify' }}>Your card will be charged 1 AUD for card preauthorization. This pending transaction will be voided by your bank automatically within 7-14 business days. Payment method can be updated anytime in Telsim My Account.</p>
                                            </div>


                                        </div>

                                        {/* Terms & Submit */}
                                        <div className="post-paid-common-section">
                                            <div className="mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="agreeToPrivacy"
                                                        checked={this.state.agreeToTerms}
                                                        onChange={this.handlecheckTermAndContition}
                                                        className="form-check-input post-paid-common-checkbox"
                                                        id="agreeToPrivacy"
                                                    />
                                                    <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToPrivacy">
                                                        I agree to Telsim’s <a href="https://www.telsim.com.au/standard-form-of-agreement-sim-only-plans" target="_blank"> Standard Form of Agreement</a>  <span style={{ color: "red" }}> *</span> and <a href="https://www.telsim.com.au/critical-information-summary/telsim-upfront-mobile-plans" target="_blank"> Critical Information Summary</a>  <span style={{ color: "red" }}> *</span>.
                                                    </label>
                                                </div>
                                                {this.state.errors.agreeToTerms && (
                                                    <div className="post-paid-common-error">
                                                        {this.state.errors.agreeToTerms}
                                                    </div>
                                                )}
                                            </div>



                                            <div className="mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="agreeToDebit"
                                                        checked={this.state.agreeDirectDebit}
                                                        onChange={this.handlecheckDirectDebit}
                                                        className="form-check-input post-paid-common-checkbox"
                                                        id="agreeToDebit"
                                                    />
                                                    <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToDebit" style={{ textAlign: 'justify' }}>
                                                        I authorise Kangaroo Telecom Pty Ltd trading as Telsim Australia (ABN: 84 628 098 966), and its appointed payment processor Braintree (a PayPal service), to debit payments from my nominated payment method as per the agreed billing schedule. These debits are for the payment of my Telsim Mobile Plan Services and may vary in amount depending on the selected plan and usage.
                                                    </label>
                                                    <p>By signing this form: </p>
                                                    <ul style={{ textAlign: 'justify' }}>
                                                        <li>I acknowledge that I have read and understood the Telsim Direct Debit Service Agreement.</li>
                                                        <li>I authorise Telsim Australia and Braintree to debit my account in accordance with the agreement.</li>
                                                        <li>I understand that dishonour fees may apply if funds are insufficient.</li>
                                                        <li>I will notify Telsim of any change to these account details or cancellation of this authority.</li>
                                                    </ul>
                                                </div>
                                                {this.state.errors.agreeDirectDebit && (
                                                    <div className="post-paid-common-error">
                                                        {this.state.errors.agreeDirectDebit}
                                                    </div>
                                                )}
                                            </div>




                                            {!this.state.hideButton&&(

                                            <button
                                                type="button"
                                                disabled={this.state.isSubmitting}
                                                className="btn post-paid-common-submit-btn"
                                                onClick={this.buy}
                                            >
                                                {this.state.isSubmitting ? (
                                                    <>
                                                        <div className="post-paid-common-spinner d-inline-block me-2"></div>
                                                        Processing...
                                                    </>
                                                ) : (
                                                    "Submit & Activate"
                                                )}
                                            </button>

                                              )}


                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Payments);
